import { MatMenu } from '@angular/material/menu';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class TituloService {

    public messageSource = new BehaviorSubject<string>('');
    public messageSourceSub = new BehaviorSubject<string>('');
    public messageSourceJogos = new BehaviorSubject<string>('');
    public tituloAtual = this.messageSource.asObservable();
    public subtituloAtual = this.messageSourceSub.asObservable();
    public diaJogo = this.messageSourceJogos.asObservable();


    constructor() { }

    alterarTitulo(titulo: string) {
      this.messageSource.next(titulo);
    }
    alterarSubTitulo(titulo: string) {
      this.messageSourceSub.next(titulo);
    }

    jogosAviso(aviso: string){
        this.messageSourceJogos.next(aviso);
    }

}
